import React, { useState } from "react";
// import emailjs from "emailjs-com";

import Loader from "../../UI/Loader/Loader";
import Button from "../../UI/button/Button";

import "./ContactForm.css";

const ContactForm = ({ dark = false }) => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [displayMessage, setDisplayMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  //   const sendFeedback = async (templateId, variables) => {
  //     await emailjs
  //       .send(
  //         "service_8ikform",
  //         templateId,
  //         variables,
  //         "user_0YQKp94AwtTs2vyjGpLal"
  //       )
  //       .then((res) => {
  //         setDisplayMessage("We will get back to you shortly!");
  //         console.log(res);
  //       })
  //       .catch((err) => {
  //         setDisplayMessage("Cannot contact, please try again");
  //         console.error("Email Error:", err);
  //       });
  //   };

  const submitHandler = async (event) => {
    event.preventDefault();
    setIsLoading(true);
    if (phone.length === 10) {
      let response = await fetch(
        `https://script.google.com/macros/s/AKfycbw9BCEDlqm3nBbtXtQ-0fX7OlI9BrGjDAXvllZ9D1RbtO9bqzoxKQnsNGjHJsygEf0/exec?name=${name}&email=${email}&phone=${phone}&subject=${subject}&message=${message}`,
        {
          method: "post",
        }
      );
      let res = await response.json();
      console.log(res);
    } else {
      setDisplayMessage("Enter valid phone number");
      setIsLoading(false);
      return;
    }

    setIsLoading(false);
    setMessage("");
    setName("");
    setPhone("");
    setSubject("");
    setEmail("");
  };

  let btnContent = isLoading ? <Loader dark={dark} /> : "Submit";
  let darkClass = dark ? "dark" : null;
  let btn = dark ? (
    <Button>{btnContent}</Button>
  ) : (
    <Button color="#ffffff" type="submit" light={true}>
      {btnContent}
    </Button>
  );

  return (
    <div className="contact-form">
      <form onSubmit={submitHandler}>
        <input
          className={`contact-form-input ${darkClass}`}
          type="text"
          placeholder="Name"
          required
          value={name}
          onChange={(e) => setName(e.target.value)}
        />{" "}
        <br />
        <input
          className={`contact-form-input ${darkClass}`}
          type="email"
          required
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />{" "}
        <br />
        <input
          className={`contact-form-input ${darkClass}`}
          type="number"
          required
          placeholder="Phone"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
        />{" "}
        <br />
        <input
          className={`contact-form-input ${darkClass}`}
          type="text"
          placeholder="Subject"
          required
          value={subject}
          onChange={(e) => setSubject(e.target.value)}
        />{" "}
        <br />
        <textarea
          className={`contact-form-textarea ${darkClass}`}
          placeholder="Message"
          required
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          rows="7"
        >
          {message}
        </textarea>{" "}
        <br />
        <div className={`contact-btn ${darkClass}`}>{btn}</div> <br />
      </form>
      <p className={`contact-message`}>{displayMessage}</p>
    </div>
  );
};

export default ContactForm;



// WEBPACK FOOTER //
// ./src/components/contact/contact-form/ContactForm.js